import {
  getDay
} from "../../utils/date";

export const __statistics__tax_invoices = {
  "data": [{
    "totalAmt": 660000,
    "supplyAmt": 600000,
    "date": getDay(6),
    "supByrType": "purchase"
  }, {
    "totalAmt": 2420000,
    "supplyAmt": 2200000,
    "date": getDay(5),
    "supByrType": "purchase"
  }, {
    "totalAmt": 4550060,
    "supplyAmt": 11361488,
    "date": getDay(4),
    "supByrType": "purchase"
  }, {
    "totalAmt": 6223487,
    "supplyAmt": 11361488,
    "date": getDay(3),
    "supByrType": "purchase"
  }, {
    "totalAmt": 8105348,
    "supplyAmt": 11361488,
    "date": getDay(2),
    "supByrType": "purchase"
  }, {
    "totalAmt": 8506740,
    "supplyAmt": 11361488,
    "date": getDay(1),
    "supByrType": "purchase"
  }, {
    "totalAmt": 660000,
    "supplyAmt": 600000,
    "date": getDay(6),
    "supByrType": "sales"
  }, {
    "totalAmt": 2420000,
    "supplyAmt": 2200000,
    "date": getDay(5),
    "supByrType": "sales"
  }, {
    "totalAmt": 9907861,
    "supplyAmt": 7125000,
    "date": getDay(4),
    "supByrType": "sales"
  }, {
    "totalAmt": 11975210,
    "supplyAmt": 8423110,
    "date": getDay(3),
    "supByrType": "sales"
  }, {
    "totalAmt": 13597920,
    "supplyAmt": 9847520,
    "date": getDay(2),
    "supByrType": "sales"
  }, {
    "totalAmt": 12497630,
    "supplyAmt": 11361488,
    "date": getDay(1),
    "supByrType": "sales"
  }, ],
  "metadata": {
    "offset": 0,
    "search": null,
    "order": null,
    "range": {
      "writeDate": {
        "from": getDay(6),
        "to": getDay(1)
      }
    }
  }
}